<template>
  <IndexPageSection
    v-if="showableEspeciallyRecommendSection"
    :need-link="false"
    :need-to-move-link-to-bottom="false"
    section-name="especially-recommend"
    :title="recommendTitle"
  >
    <div class="especially-recommend__lead">
      <span>{{ recommendDescription }}</span>
    </div>
    <a :href="recommendLinkUrl" @click="clickRecommendLinkUrl">
      <img
        class="especially-recommend__ogp"
        :src="ogpImage"
        :alt="ogpImageAlt"
      />
    </a>
  </IndexPageSection>
</template>

<script>
import IndexPageSection from './IndexPageSection'
import dayjs from 'dayjs'

export default {
  components: { IndexPageSection },
  data() {
    // 差し替え時は clickRecommendLinkUrl の announcement_id も変更すること。
    return {
      ogpImage:
        'https://static.giftee.com/master_data/images/announcement_thumbnails/276/Giftee_Combination-02.png',
      ogpImageAlt: '組み合わせギフト画像',
      recommendTitle: 'もっとキモチが伝わる、ギフトの贈り方',
      recommendDescription: 'みんなが贈っている組み合わせは？',
      recommendLinkUrl: '/announcements/276',
      showableEspeciallyRecommendSection: false,
      showableDate: '2023-06-06 23:59:59'
    }
  },
  mounted() {
    this.showableEspeciallyRecommendSection = dayjs().isSameOrBefore(
      this.showableDate
    )
  },
  methods: {
    clickRecommendLinkUrl() {
      dataLayer.push({
        event: 'select_top_area_promotion',
        announcement_id: '276'
      })
    }
  }
}
</script>

<!-- NOTE: IndexPageが現状グローバルCSS前提のため、ここも scoped を外す -->
<style lang="scss">
.especially-recommend {
  @extend %top-section;

  &__ogp {
    width: 100%;
    border-radius: 8px;
    border: 1px solid $gray-2;
  }

  &__container {
    @extend %top-section__container;
  }

  &__head {
    margin: 24px 0 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__title {
    @extend %top-section__title;
  }

  &__lead {
    @extend %top-section__lead;
  }
}

@media all and (min-width: $sp-width + 1) {
  .especially-recommend {
    display: none;
  }
}
</style>
